import React from 'react';
import { ButtonsContainer, FormContainer } from '../../components/Layout';
import {
  Button,
  FieldsMapper,
  InputSelect,
  Spinner,
} from '../../components/Common';
import ModalContent from '../../components/Common/Modal/ModalContent';
import ModalTitle from '../../components/Common/Modal/ModalTitle';
import ModalHeader from '../../components/Common/Modal/ModalHeader';
import { __ } from '../../services/translation';
import { modal, recipes } from '../../actions';
import { useDispatch } from 'react-redux';
import ReactSelect from 'react-select';
import ItfApiForm from '../../components/Common/TrackedItfApiForm';
import { RecipeComponentDetails, SelectOption } from 'profilpol-types';
import { successNotification } from '../../actions/notifications';
import { ButtonType } from '../../components/Common/Button';
import ApiService from '../../services/api-service';
import { pathToObject } from '../../utils/path-to-object';
import { formOnTranslateString } from '../../utils/trans-form';

interface Props {
  recipeId: string;
  id?: string;
}

const RecipeComponent = ({ recipeId, id }: Props) => {
  const dispatch = useDispatch();

  return (
    <ModalContent>
      <ModalHeader>
        <ModalTitle
          title={id ? 'recipe.edit_component' : 'recipe.new_component'}
        />
      </ModalHeader>
      <FormContainer>
        <ItfApiForm
          unsavedScope="modal"
          formId="recipeComponentForm"
          schemaMayBeDynamic={true}
          schemaCacheEnabled={false}
          loadingInfoAboveContent
          loadingInfo={<Spinner overlay halfTransparent />}
          sendDelay={200}
          requiredIndicator="*"
          schemaFetcher={() =>
            ApiService.loadForm(
              id
                ? `recipe/form/update-component/${recipeId}/${id}`
                : `recipe/form/add-component/${recipeId}`
            )
          }
          sendFetcher={(formId: string, values: any) => {
            const field = {
              ...values,

              recipeId,
            };
            return ApiService.sendForm(
              id ? `recipe/component/${id}` : 'recipe/component',
              pathToObject(field),
              id ? 'PATCH' : 'POST',
              null
            );
          }}
          submitButton={(loading: boolean) => (
            <ButtonsContainer>
              <Button
                disabled={loading}
                small
                type={ButtonType.Button}
                danger
                click={() => dispatch(modal.hideModal())}
                text={'application.cancel'}
              />
              <Button
                disabled={loading}
                small
                type={ButtonType.Submit}
                success
                text={'application.save'}
              />
            </ButtonsContainer>
          )}
          onRenderFullField={(
            field,
            errors,
            fieldHtmlId,
            currentValue,
            onChange,
            onFocus,
            onBlur
          ) =>
            FieldsMapper(
              field,
              errors,
              fieldHtmlId,
              currentValue,
              onChange,
              onFocus,
              onBlur,
              { recipeId }
            )
          }
          onSavedSuccessfully={(data: RecipeComponentDetails) => {
            dispatch(
              successNotification(
                id ? 'recipe.component_updated' : 'recipe.component_created'
              )
            );
            if (id) {
              dispatch(recipes.updateRecipeComponent(data));
            } else {
              dispatch(recipes.addNewComponent(data));
            }
            dispatch(modal.hideModal());
          }}
          onTranslateString={formOnTranslateString}
          thirdPartyComponents={{
            ReactSelect,
            ReactCreatableSelect: InputSelect,
          }}
        />
      </FormContainer>
    </ModalContent>
  );
};

export default RecipeComponent;
